import useMediaQuery from 'hooks/useMediaQuery';
import React from 'react';
import styled from 'styled-components';
import FilterComponent from 'ui/components/shared/DataTable/SubHeader/FilterComponent';
import { Container, Title } from 'ui/components/styled';
import device from 'ui/theme/device';

const HeaderComponent = ({
  title,
  titleProps,
  count,
  countProps,
  actions,
  disposition = 'default',
  filterPlaceholder,
  filterValue,
  advancedSearch,
  advancedSearchOpen,
  setAdvancedSearchOpen,
  openMobileFilter,
  filterWidth = '40%',
  onFilter,
  ...rest
}) => {
  const isSmall = useMediaQuery(device.small);

  const renderHeader = (disposition) => {
    switch (disposition) {
      case 'actions-first':
        return (
          <Container
            flexDirection={isSmall ? 'column' : 'row'}
            justifyContent="space-between"
            width="auto"
            flexGrow="1"
          >
            {actions && (
              <Container flexDirection="row" alignItems="center" width="auto" height="auto" mr="m">
                {actions}
              </Container>
            )}
            {!isSmall && (
              <Container flexDirection="row" alignItems="center" width={filterWidth} height="auto">
                <FilterComponent
                  placeholder={filterPlaceholder}
                  value={filterValue}
                  onFilter={onFilter}
                  advancedSearch={advancedSearch}
                  advancedSearchOpen={advancedSearchOpen}
                  setAdvancedSearchOpen={setAdvancedSearchOpen}
                  width="100%"
                />
              </Container>
            )}
            {isSmall && openMobileFilter && (
              <Container flexDirection="row" alignItems="center" width="100%" height="auto" mt="s">
                <FilterComponent
                  placeholder={filterPlaceholder}
                  value={filterValue}
                  onFilter={onFilter}
                  advancedSearch={advancedSearch}
                  width="100%"
                />
              </Container>
            )}
            {count && <Count {...countProps}>{count}</Count>}
          </Container>
        );
      case 'actions-after-filter':
        return (
          <>
            <Container flexDirection="row" alignItems="center" width={filterWidth} height="auto">
              <FilterComponent
                placeholder={filterPlaceholder}
                value={filterValue}
                onFilter={onFilter}
                advancedSearch={advancedSearch}
                width="100%"
              />
              {actions && (
                <Container
                  flexDirection="row"
                  alignItems="center"
                  width="auto"
                  height="auto"
                  ml="m"
                >
                  {actions}
                </Container>
              )}
            </Container>
            {count && <Count {...countProps}>{count}</Count>}
          </>
        );
      default:
        return (
          <>
            <FilterComponent
              placeholder={filterPlaceholder}
              value={filterValue}
              onFilter={onFilter}
              advancedSearch={advancedSearch}
              width={filterWidth}
            />
            <Container flexDirection="row" alignItems="center" width="auto" height="auto">
              {actions && (
                <Container
                  flexDirection="row"
                  alignItems="inherit"
                  width="auto"
                  height="auto"
                  mr="m"
                >
                  {actions}
                </Container>
              )}
              {count && <Count {...countProps}>{count}</Count>}
            </Container>
          </>
        );
    }
  };

  return (
    <Container
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      height="auto"
      pb="m"
      pt="3px"
      pr="3px"
      {...rest}
    >
      {title && (
        <Title variant="primary" minWidth="200px" {...titleProps}>
          {title}
        </Title>
      )}
      {renderHeader(disposition)}
    </Container>
  );
};

const Count = styled.span`
  user-select: none;
  margin-left: 24px;
  font-weight: normal;
  font-size: 13px;
  color: #888;
  ${({ pull }) =>
    pull === 'right' &&
    `
    text-align: right;
    flex-grow: 1;
  `}
`;

export default HeaderComponent;
